import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface StyleProps {
  disabled?: boolean;
  isListOpened?: boolean;
  height?: string;
}

// Ask
export const Hint = styled.span`
  font-size: 12px;
  font-family: Audi Type;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey60};
  ${({ disabled }: StyleProps) => {
    if (disabled)
      return css`
        color: ${COLORS.grey15};
      `;
    return '';
  }}
`;

export const Label = styled.div`
  font-size: 16px;
  font-family: Audi Type;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.black};
  text-align: left;
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.002px;
    svg {
      transform: rotate(90deg);
      width: 18px;
      height: 18px;
    }
  }
  margin-top: ${SIZING.unit(0.125)};
  margin-bottom: ${SIZING.unit(0.125)};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ disabled }: StyleProps) => {
    if (disabled)
      return css`
        color: ${COLORS.grey30};
      `;
    return '';
  }}
`;

export const SelectedResult = styled.div`
  font-size: 12px;
  font-family: Audi Type;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${COLORS.grey60};
  text-align: left;
`;

export const Count = styled.span`
  font-weight: bold;
  ${({ disabled }: StyleProps) => {
    if (disabled)
      return css`
        color: ${COLORS.grey15};
        font-weight: 400;
      `;
    return '';
  }}
`;

export const DealersSelectorButton = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  padding: ${SIZING.unit(0)};
  cursor: pointer;
  align-items: flex-start;
  ${({ disabled }: StyleProps) => {
    if (disabled)
      return css`
        color: ${COLORS.grey15};
        font-weight: 400;
      `;
    return '';
  }}
`;

export const Text = styled.div`
  color: ${COLORS.grey60};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.002px;
  font-family: Audi Type;
  @media ${device.tablet} {
    font-size: 16px;
    letter-spacing: 0.002px;
  }
  span {
    color: ${COLORS.black};
  }
`;

export const ListInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
  padding-bottom: ${SIZING.unit(3)};
  @media ${device.tablet} {
    padding-bottom: ${SIZING.unit(3.5)};
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    padding-bottom: ${SIZING.unit(3)};
  }
`;

export const DealersListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  overflow-y: auto;
  max-height: 490px;
  max-height: unset;
  @media ${device.tablet} {
    padding: ${SIZING.unit(0)} ${SIZING.unit(3)};
    max-height: 490px;
  }
  @media (max-height: 800px) {
    max-height: calc(100vh - 315px);
    max-height: unset;
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    max-height: calc(100vh - 120px);
    margin-bottom: ${SIZING.unit(3)};
    padding: unset;
  }
`;

export const DealersListContainer = styled.div`
  position: absolute;
  bottom: 96px;
  max-height: calc(100vh - 96px);
  max-height: 100%;
  position: fixed;
  bottom: 0;
  padding-bottom: 96px;
  @media ${device.tablet} {
    bottom: 56px;
    max-height: calc(766px - 102px);
    position: absolute;
    padding-bottom: unset;
  }
  width: 100%;
  background-color: ${COLORS.white};
  z-index: 4;
  left: 0;
  min-height: 256px;
  display: flex;
  flex-direction: column;
  @media (min-width: 600px) and (max-height: 766px) {
    bottom: 56px;
    max-height: calc(100vh - 102px);
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    position: fixed;
    bottom: 0;
    max-height: 100%;
    overflow-y: auto;
  }
`;

export const DealerItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  input {
    height: 20px !important;
  }
`;

export const DealerItemInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const DealerNameLabel = styled.div`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  word-break: break-all;
`;

export const DealerCityLabel = styled.div`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey60};
  margin-top: ${SIZING.unit(0.5)};
`;

export const AddressIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${COLORS.grey50};
  white-space: nowrap;
`;

export const DealersListPadding = styled.div`
  padding: ${SIZING.unit(0)} ${SIZING.unit(3.5)};
  padding-top: ${SIZING.unit(3)};
  padding-bottom: ${SIZING.unit(3)};
  flex-grow: 1;
  // height: 100%;
  overflow-y: auto;
  @media ${device.tablet} {
    padding: ${SIZING.unit(0)} ${SIZING.unit(6)};
    padding-top: ${SIZING.unit(3)};
    padding-bottom: ${SIZING.unit(5.25)};
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    padding-top: ${SIZING.unit(3)};
    padding-bottom: ${SIZING.unit(4)};
  }
`;

export const BackButtonWrapper = styled.div`
  margin-bottom: ${SIZING.unit(3)};
  @media ${device.tablet} {
    margin-bottom: ${SIZING.unit(3.5)};
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    margin-bottom: ${SIZING.unit(3)};
  }
`;

export const CountWrapper = styled.div`
  ${({ disabled }: StyleProps) => {
    if (disabled)
      return css`
        color: ${COLORS.grey15};
      `;
    return '';
  }}
`;

export const ButtonWrapper = styled.div`
  display: none;
  ${({ isListOpened }: StyleProps) => {
    if (isListOpened)
      return css`
        @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
          display: block;
        }
      `;
    return '';
  }}
`;
